import React from 'react';
import PropTypes from 'prop-types';
import { CalculatorStepItem } from 'site-modules/calculators/components/calculator-step-item/calculator-step-item';
import { CalculatorRowItem } from 'site-modules/calculators/components/calculator-row-item/calculator-row-item';
import { PaymentInput } from 'site-modules/shared/components/calculator/payment-input/payment-input';
import { PAYMENT_INPUT_PROPS } from 'site-modules/calculators/constants/calculators';

export function GasGuzzlerGasMileageStep(props) {
  const { fuelPerGallon, mileagePerMonth, onKeyPress, onInputChange } = props;

  return (
    <CalculatorStepItem stepName="Gas and Mileage">
      <CalculatorRowItem title="Number of miles driven per month">
        <PaymentInput
          name="mileagePerMonth"
          key={mileagePerMonth}
          value={mileagePerMonth}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          isCurrency
          {...PAYMENT_INPUT_PROPS}
          inputAriaLabel="Number of miles driven per month"
        />
      </CalculatorRowItem>
      <CalculatorRowItem title="Fuel cost per gallon">
        <PaymentInput
          name="fuelPerGallon"
          key={fuelPerGallon}
          value={fuelPerGallon}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          isCurrency
          {...PAYMENT_INPUT_PROPS}
          inputAriaLabel="Fuel cost per gallon"
        />
      </CalculatorRowItem>
    </CalculatorStepItem>
  );
}

GasGuzzlerGasMileageStep.propTypes = {
  fuelPerGallon: PropTypes.number.isRequired,
  mileagePerMonth: PropTypes.number.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
};
